import { defineComponent as _defineComponent } from 'vue'
import { Link } from "@inertiajs/vue2";
import { Swiper, SwiperSlide } from "swiper-vue2";
import HelpScrollingArticle from "@/components/help/HelpScrollingArticle.vue";
import "swiper/swiper-bundle.css";


export default /*#__PURE__*/_defineComponent({
  __name: 'HelpRelatedArticle',
  props: {
    related: null
  },
  setup(__props: any) {

const props = __props as {
  related: Array<{
    id: number;
    title: string;
    imageUrl: string;
    description: string;
    category: string;
  }>;
};



return { __sfc: true,props, Link, Swiper, SwiperSlide, HelpScrollingArticle }
}

})